import { Box } from "@mui/material";
import { useSyncHeight } from "./useSyncHeight";
import styles from "./styles.module.scss";

const StickySideBar = (props) => {
  const { children, element } = props;
  const wrapperRef = useSyncHeight({ element });

  if (!children) return null;

  return (
    <Box className={styles.wrapper} ref={wrapperRef}>
      <Box className={styles.content}>
        <Box className={styles.sticky}>
          <Box className={styles.stickyContent}>{props.children}</Box>
        </Box>
      </Box>
    </Box>
  );
};

export default StickySideBar;
